import React from "react";

const TypeFailIDX = (num) => {
  var lable = "";
  switch (num) {
    case 1:
      lable = "Fail Score";
      break;
    case 2:
      lable = "Fail Attendance";
      break;
    case 3:
      lable = "Fail Cheating";
      break;
    case 9:
      lable = "Failed Score and Attendance";
      break;

    default:
      break;
  }
  return lable;
};

const GroupByKey = (list, key) => {
  var result = list.reduce(
    (hash, obj) => ({
      ...hash,
      [obj[key]]: (hash[obj[key]] || []).concat(obj),
    }),
    {}
  );
  return result;
};

const CapitalizeEachWord = (str) => {
  return str.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  );
};

const LoopWeekDay = (now) => {
  var weekdays = [];
  for (let i = 1; i <= 6; i++) {
    const day = now.clone().weekday(i);
    weekdays.push({
      name: day.format("dd"), // Format the day name (e.g., Monday)
      date: day.format("YYYY-MM-DD"), // Format the date (e.g., 2023-09-01)
    });
  }

  return weekdays;
};

const FormatRupiah = (angka, prefix) => {
  var number_string = angka
    .toString()
    .replace(/[^,\d]/g, "")
    .toString(),
    split = number_string.split(","),
    sisa = split[0].length % 3,
    rupiah = split[0].substr(0, sisa),
    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

  // tambahkan titik jika yang di input sudah menjadi angka ribuan
  var separator = "";
  if (ribuan) {
    separator = sisa ? "." : "";
    rupiah += separator + ribuan.join(".");
  }

  rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
  return prefix == undefined ? rupiah : rupiah ? rupiah : "";
};

const CleansingJSON = (data) => {
  let cleansedData = data.replace(/([{,]\s*)(\w+)\s*:/g, '$1"$2":');
  cleansedData = JSON.parse(cleansedData);
  return cleansedData;
};

const StudentIDFormat = (number) => {
  if (number && number.length === 9) {
    return number.toString().replace(/(\d+)(\d{3})(\d{3})$/, "$1-$2-$3");
  } else {
    return number;
  }
};

const RemoveEmptyValue = (dataArr) => {
  const newData = { ...dataArr };

  for (const key in newData) {
    if (newData[key] === "" || newData[key] === 0 || newData[key] === null) {
      delete newData[key];
    }
  }

  return newData;
};

const EnrollmentStdType = (typeid) => {
  let enrollType = "";
  if (typeid === "mkt.enrollment.type.transfer.in.external") {
    enrollType = "Transfer";
  } else {
    var enrollment = typeid;
    var enrollmentArr = enrollment.split(".");
    enrollType = enrollmentArr[Object.values(enrollmentArr).length - 1];
  }
  return enrollType;
};

const TransferType = (typeid) => {
  let transType = "";
  if (typeid === "mkt.enrollment.transfer.type.learningprogram") {
    transType = "RPL";
  } else {
    const transid = typeid;
    const transArr = transid.split(".");
    transType = transArr[Object.values(transArr).length - 1];
  }
  return transType;
};


// const EncodeURIComponentSafe = (input) => {
//   if (input === null || input === undefined || input === "") {
//     return "";
//   }

//   try {
//     const base64 = btoa(input);

//     return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
//   } catch (error) {
//     return input;
//   }

// };


const EncodeURIComponentSafe = (input) => {
  if (input === null || input === undefined || input === "") {
    return "";
  }
  try {
    // Convert string to UTF-8 bytes
    const utf8Bytes = new TextEncoder().encode(input);
    // Convert bytes to a binary string
    const binaryString = Array.from(utf8Bytes)
      .map((byte) => String.fromCharCode(byte))
      .join("");
    // Encode to Base64
    const base64 = btoa(binaryString);

    return base64
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  } catch (error) {
    console.error("Encoding error:", error);
    return input;
  }
};

const DecodeURIComponentSafe = (encodedInput) => {
  if (
    encodedInput === null ||
    encodedInput === undefined ||
    encodedInput === ""
  ) {
    return "";
  }

  let base64 = encodedInput.replace(/-/g, "+").replace(/_/g, "/");

  while (base64.length % 4) {
    base64 += "=";
  }

  try {
    // Decode from Base64 to a binary string
    const binaryString = atob(base64);
    // Convert the binary string to a byte array
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    // Decode the byte array as UTF-8
    return new TextDecoder().decode(bytes);
  } catch (error) {
    console.error("Decoding error:", error);
    return "";
  }
};

function splitFullName(fullname) {
  let firstname = "";
  let middlename = "";
  let lastname = "";
  if (fullname) {
    // Menghilangkan spasi di awal dan akhir, lalu memisahkan nama berdasarkan spasi
    const nameParts = fullname.trim().split(/\s+/);
    if (nameParts.length === 1) {
      // Jika hanya ada satu kata, itu menjadi firstname
      firstname = nameParts[0];
    } else if (nameParts.length === 2) {
      // Jika ada dua kata, kata pertama menjadi firstname, kata kedua menjadi lastname
      [firstname, lastname] = nameParts;
    } else if (nameParts.length === 3) {
      // Jika ada tiga kata, dibagi menjadi firstname, middlename, dan lastname
      [firstname, middlename, lastname] = nameParts;
    } else {
      // Jika lebih dari tiga kata
      firstname = nameParts[0];
      lastname = nameParts[nameParts.length - 1];
      middlename = nameParts.slice(1, -1).join(" ");
    }
  }

  return { firstname, middlename, lastname };
}


export { TypeFailIDX, GroupByKey, LoopWeekDay, FormatRupiah, CapitalizeEachWord, CleansingJSON, StudentIDFormat, RemoveEmptyValue, EnrollmentStdType, EncodeURIComponentSafe, DecodeURIComponentSafe, splitFullName, TransferType };
